<template>
  <v-app v-if="extensionVisible">
    <v-main ref="appMain" id="appMain">
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { resolveLocale } from "./utils/locale";
export default {
  name: "App",
  components: {},
  data: () => ({}),
  methods: {
    ...mapActions(["getShopPreferences", "setShop", "setToken"]),
    ...mapMutations(['setThemeJson']),

    /**
     * Notify iframe change height app
     */
    iframeHeightNotify() {
      if (!this.extensionVisible) return;

      const that = this;
      const resizeObserver = new ResizeObserver(function () {
        window.parent.postMessage(
          JSON.stringify({
            type: "resize",
            data: {
              height: that.$refs.appMain.$el.scrollHeight,
            },
          }),
          "*"
        );
      });

      resizeObserver.observe(document.getElementById("appMain"));
    },
  },
  computed: {
    ...mapState(['themeJson', 'extensionVisible']),
    ...mapGetters(["preferences"]),
  },
  mounted() {
    this.setShop(this.$route.query.shop);
    this.setToken(this.$route.query.token);

    const initialParamLang = new URLSearchParams(window.location.search).get("default-language");
    const browserLangs = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language];
    if (initialParamLang !== null) {
      this.$i18n.locale = resolveLocale("auto", initialParamLang, browserLangs, Object.keys(this.$i18n.messages));
    }

    this.getShopPreferences().finally(() => {
      const paramLang = this.$route.query["default-language"];
      this.$i18n.locale = resolveLocale(this.preferences.lang, paramLang, browserLangs, Object.keys(this.$i18n.messages));
      if(this.preferences.theme) {
        this.setThemeJson(this.preferences.theme);
      }
    });

    this.iframeHeightNotify();
  },
  beforeDestroy() {
    //
  },
};
</script>

<style lang="scss">
.v-application--wrap {
  min-height: inherit !important;
}
</style>
